import React, { useContext } from 'react';
import { canDeleteUpload } from '../../../../common/actionHelper';
import { useCaseLock } from '../../../../common/caseLocking/CaseLockContext';
import { Resource } from '../../../../common/constants/resource';
import { AuthContext } from '../../../login/AuthWrapper';
import { Document } from '../../../tasks/types/document';
import { FileDetailsItem } from './FileDetailsItem';

export const FileDetail = ({
  documents,
  displayString,
  fileOpenHandler,
  fileDeletehandler,
  canDeleteFile = true,
}: {
  documents: Document[];
  displayString?: string;
  fileOpenHandler: (uri: string, fileName: string) => void;
  fileDeletehandler?: (documentId: number, reason: string) => void;
  canDeleteFile?: boolean;
}) => {
  const auth = useContext(AuthContext);
  const { isLockedForActions } = useCaseLock();
  const canDelete =
    canDeleteFile && canDeleteUpload(auth.roles) && !isLockedForActions;

  return (
    <>
      {documents.map((item, index) => {
        let leftItemValue = '';
        if (index === 0) {
          leftItemValue = displayString || Resource.FILES;
        }
        return (
          <FileDetailsItem
            canDelete={canDelete}
            key={index}
            leftItem={leftItemValue}
            document={item}
            fileOpenHandler={fileOpenHandler}
            fileDeletehandler={fileDeletehandler}
          />
        );
      })}
    </>
  );
};
